
import NewCategory from "../features/inventory/NewCategory"

const NewInventoryCategoryPage = () => {
    return (
        <NewCategory />
    )
}

export default NewInventoryCategoryPage